import Vue from 'vue'
import Router from 'vue-router'
import MainLayout from '@/layout/MainLayout'
import store from './store/store'

Vue.use(Router)

const router = new Router({
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: 'privacy',
      component: MainLayout,
      children: [
        {
          path: 'privacy',
          name: 'privacy',
          component: () => import(/* webpackChunkName: "privacy" */ './views/PrivacyImportant.vue')
        },
        {
          path: 'gender',
          name: 'gender',
          component: () => import(/* webpackChunkName: "gender" */ './views/Gender.vue')
        },
        {
          path: 'who-are-you',
          name: 'whoareyou',
          component: () => import(/* webpackChunkName: "whoareyou" */ './views/WhoAreYou.vue')
        },
        {
          path: 'chronic-condition',
          name: 'chroniccondition',
          component: () => import(/* webpackChunkName: "chroniccondition" */ './views/ChronicCondition.vue')
        },
        {
          path: 'how-pandemic-affected-you',
          name: 'howpandemicaffected',
          component: () => import(/* webpackChunkName: "howpandemicaffected" */ './views/HowPandemicAffected.vue')
        },
        {
          path: 'catch-covid19',
          name: 'catchcovid19',
          component: () => import(/* webpackChunkName: "catchcovid19" */ './views/CatchCOVID.vue')
        },
        {
          path: 'treatment-open-getting',
          name: 'treatmentopengetting',
          component: () => import(/* webpackChunkName: "treatmentopengetting" */ './views/TreatmentOpenToGetting.vue')
        },
        {
          path: 'would-you-get-vaccinated',
          name: 'wouldgetvaccinated',
          component: () => import(/* webpackChunkName: "wouldgetvaccinated" */ './views/WouldGetVaccinated.vue')
        },
        {
          path: 'preventative-health',
          name: 'preventativehealth',
          component: () => import(/* webpackChunkName: "preventativehealth" */ './views/PreventativeHealthPrecautions.vue')
        },
        {
          path: 'why-concerned',
          name: 'whyconcerned',
          component: () => import(/* webpackChunkName: "whyconcerned" */ './views/WhyConcerned.vue')
        },
        {
          path: 'worry-about-risks',
          name: 'worryaboutrisks',
          component: () => import(/* webpackChunkName: "worryaboutrisks" */ './views/WorryAboutRisks.vue')
        },
        {
          path: 'household-income',
          name: 'householdincome',
          component: () => import(/* webpackChunkName: "householdincome" */ './views/HouseholdIncome.vue')
        },
        {
          path: 'concerned-about-vaccination',
          name: 'concernedaboutvaccination',
          component: () => import(/* webpackChunkName: "concernedaboutvaccination" */ './views/ConcernedAboutVaccination.vue')
        },
        {
          path: 'ethnicity',
          name: 'ethnicity',
          component: () => import(/* webpackChunkName: "ethnicity" */ './views/Ethnicity.vue')
        },
        {
          path: 'education',
          name: 'education',
          component: () => import(/* webpackChunkName: "education" */ './views/Education.vue')
        },
        {
          path: 'source-of-stress',
          name: 'sourceofstress',
          component: () => import(/* webpackChunkName: "sourceofstress" */ './views/SourceOfStress.vue')
        },
        {
          path: 'results',
          name: 'results',
          component: () => import(/* webpackChunkName: "results" */ './views/Results.vue')
        },
        {
          path: 'almost-done',
          name: 'almostdone',
          component: () => import(/* webpackChunkName: "almostdone" */ './views/AlmostDone.vue')
        },
        {
          path: 'thank-you',
          name: 'thankyou',
          component: () => import(/* webpackChunkName: "thankyou" */ './views/ThankYou.vue')
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const surveyComplete = store.getters.SurveyComplete
  const lastPage = store.getters.getLastPage

  if (surveyComplete && to.path !== '/thank-you' && to.path !== '/results') {
    next('thank-you')
  } else if (lastPage === '' && to.path !== '/privacy' && !from.name) {
    next('privacy')
  } else if (lastPage !== '' && !from.name && to.name !== lastPage) {
    next({
      name: lastPage
    })
  } else {
    next()
  }
})

export default router
